import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { ProdOrderTransit, TransitAssignment, TransitAssignmentUpdate } from './prod-order-transit'
import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class ProdOrderTransitService extends RestClientPaged<ProdOrderTransit, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)
    super(environment.apiPath + '/prod-order-transits', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  patchAssignment(
    prodOrderTransit: ProdOrderTransit,
    transitAssignment: TransitAssignment
  ): Observable<ProdOrderTransit> {
    const update = <TransitAssignmentUpdate>{
      workOrderId: transitAssignment.workOrderId,
      deliveryId: transitAssignment.deliveryId,
    }
    const url =
      this.getEntityUrl(prodOrderTransit.id) + '/assignments/' + transitAssignment.workOrderId
    return this.http.patch<ProdOrderTransit>(url, update)
  }
}
